"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./index.scss");
const mobx_react_1 = require("mobx-react");
const mobx_1 = require("mobx");
class ToggleSelector extends react_1.default.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "isChecked", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: this.props.checkedSecondOption || false
        });
        Object.defineProperty(this, "isSomeChecked", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "allCheckedToggle", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                if (this.isSomeChecked) {
                    this.isSomeChecked = false;
                    this.isChecked = true;
                    return;
                }
                this.isChecked = !this.isChecked;
                this.props.onClick(this.isChecked ? this.props.option2 : this.props.option1);
            }
        });
        (0, mobx_1.makeObservable)(this, {
            isChecked: mobx_1.observable,
            isSomeChecked: mobx_1.observable,
            allCheckedToggle: mobx_1.action,
        });
    }
    render() {
        const { mainColor, disabled, option1, option2 } = this.props;
        const classNames = [
            'toggle-selector-component',
            mainColor ? 'main-color-set' : 'second-color-set',
            disabled ? 'disabled' : '',
        ].join(' ');
        return (react_1.default.createElement("div", { className: classNames, onClick: !disabled ? this.allCheckedToggle : () => { }, "data-testid": "toggle-label-component" },
            react_1.default.createElement("span", { className: "toggle-option small" }, option1),
            react_1.default.createElement("div", { className: ['toggle-wrapper', 'small', this.isChecked ? 'checked' : ''].join(' ') }),
            react_1.default.createElement("span", { className: "toggle-option small" }, option2)));
    }
}
exports.default = (0, mobx_react_1.observer)(ToggleSelector);
